// exceljs插件
// import { timeFormat } from '@/filters';
import saveAs from 'file-saver';
// import { saveAs } from "file-saver";

const Excel = require('exceljs');

function exportExcelJs(
  DataResult,
  fileName
) {
  let workbook = new Excel.Workbook();
  workbook.created = new Date();
  workbook.modified = new Date();
  for (let i = 0; i < DataResult.length; i++) {
    let Data = DataResult[i].results;
    let columns = DataResult[i].columns;
    let sheetType = DataResult[i].type;
    let sheetName = DataResult[i].sheetName;
    // 普通文本
    if(sheetType == 'text'){
      let worksheet = workbook.addWorksheet(sheetName);
      columns = columns.map((item) => {
        return Object.assign(
          {},
          {
            header: item.title,
            // width: item.types == 'date' || item.types == 'image' ? 30 : 15,
          },
          item
        );
      });
      worksheet.columns = columns;
      for (let i = 0; i < Data.length; i++) {
        let list = [];
        let rowData = {};
        for (let j = 0; j < columns.length; j++) {
          if (columns[j].types == 'text' || columns[j].types == undefined) {
            rowData[columns[j].key] = Data[i][columns[j].key];
          } else if (columns[j].types == 'date') {
            // rowData[columns[j].key] = timeFormat(Data[i][columns[j].key]);
          } else if (columns[j].types == 'image') {
            let imageId2 = workbook.addImage({
              base64: Data[i][columns[j].key],
              extension: 'jpeg',
            });
            worksheet.addImage(imageId2, {
              tl: { col: 0.5 + j, row: 1.5 + i },
              ext: { width: 80, height: 80 },
            });
          }
        }
        
        // 添加一行数据
        list.push(rowData);
        worksheet.addRows(list);
        // 获取表头行（第一行）
        const headerRow = worksheet.getRow(1);
        // 设置行高（单位：磅，1 磅 ≈ 1.33 像素）
        headerRow.height = 20; // 例如：30 磅
        // 遍历表头行中的每个单元格，并设置字体加粗
        headerRow.eachCell((cell, number) => {
          cell.font = { bold: true };
        });
        // 获取最后一行
        let row = worksheet.lastRow;
        // 设置特定的行高
        row.height = 20;
        row.commit();
        // 设置单元格样式
        for (let n = 0; n < columns.length; n++) {
          let dobCol = worksheet.getColumn(n + 1);
          dobCol.eachCell(function(cell, rowNumber) {
            cell.alignment = { vertical: 'middle', horizontal: 'left' };
            // if(cell.text == '备注：' || cell.text.includes('1.全球商情信息平台的基础数据来源于全球各国/地区的官方公开平台、市场公开平台、商业数据合作伙伴和全球信息供应商。') || cell.text.includes('2.全球商情信息平台展示的涉及金额、比率、指数和评估评级等数值，除全球各国/地区的官方公开平台、市场公开平台公开公布的，其他均为第三方通过分析模型的计算和预测参考，有可能并非精确数值。') ){
            //   cell.font = { color: { argb: '1EB965' } };
            // }
          });
        }
      };
    }
    // 图片
    else if(sheetType == 'image'){
      const picsheet = workbook.addWorksheet(sheetName)
      let imageId2 = workbook.addImage({
        base64: Data.url,
        extension: 'jpeg',
      });
      
      picsheet.addImage(imageId2, {
        tl: { col: 3, row: 4 },
        ext: { width: Data.width, height: Data.height }
      });
    }
  };

  workbook.xlsx.writeBuffer().then((buffer) => {
    (saveAs)(
      new Blob([buffer], {
        type: 'application/octet-stream',
      }),
      fileName + '.' + 'xlsx'
    );
  });
}

export { exportExcelJs };







